import { ClientMessagesStatusMap, ClientMessagesTypeMap } from '@tassat/common-definitions';
import { ClientMessageRecordExtended } from '@tassat/fred-extended-definitions';

import { download } from 'Lib/exportHelper';
import { formatEpochDate } from 'Lib/stringHelpers';

export const exportClientMessages = (messages: ClientMessageRecordExtended[]) => {
    let exportString = 'Status,Type,Created At,Created By,Modified At,Modified By,Approved By,Message Content,Start Date/Time,End Date/Time\n';
    messages.forEach(message => {
        const createTime = message?.CreatedAt !== '0' ? formatEpochDate(message.CreatedAt) : '-';
        const modifyTime = message?.UpdatedAt !== '0' ? formatEpochDate(message.UpdatedAt) : '-';
        const startTime = message?.StartAt !== '0' ? formatEpochDate(message.StartAt) : '-';
        const endTime = message?.EndAt !== '0' ? formatEpochDate(message.EndAt) : '-';

        const msg = message.Message.replace(/[**|_]/gm, '');
        exportString +=
        `"${ClientMessagesStatusMap[message.Status]}","${ClientMessagesTypeMap[message.ClientMsgType]}","${createTime}","${message.CreatedByUsername}","${modifyTime}","${message.ModifiedByUsername}","${message.ApprovedByUsername}","${msg}","${startTime}","${endTime}"\n`;
    });

    download('exported_client_messages.csv', exportString);
};